"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const styles_1 = require("@material-ui/core/styles");
exports.mainBlue = "#2A7BEC";
const useAutomlStyles = styles_1.makeStyles((theme) => ({
    topicFont: {
        fontSize: "16px",
        fontWeight: 500,
        lineHeight: "24px",
        color: "#324054",
        fontWeight: "bold",
    },
    textFieldFont: {
        fontSize: "14px",
        fontWeight: 300,
        lineHeight: "24px",
        color: "#324054",
        '& .MuiFormControl-root': {
            width: "100%",
            margin: "0"
        },
    },
    mainTitleStyle: {
        fontSize: "20px",
        fontWeight: 600,
        lineHeight: "30px",
        color: exports.mainBlue,
    },
    outlinedInputOverwrite: {
        "& .MuiOutlinedInput-input": {
            padding: "8.5px 14px",
            minHeight: "1.4375em"
        }
    },
    graphContainer: {
        borderColor: "#005B96",
        borderRadius: "10px",
        padding: "20px",
        maxHeight: "450px",
        backgroundColor: 'white'
    },
    graphWarning: {
        border: '1px solid #FF4343',
        borderRadius: '8px',
        textAlign: 'center',
        height: '180px',
        color: '#FF4343',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    warningIconContainer: {
        borderRadius: '50%',
        backgroundColor: '#FF43430D',
        padding: '10px',
        width: '48px',
        height: '48px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    warnigIcon: {
        width: '24px',
        height: '24px'
    },
    graph: {
        overflowY: 'auto',
        backgroundColor: 'white'
    },
    graphPlot: {
        width: "100%",
        height: "380px",
        overflow: "auto"
    },
    graphPopHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        position: "sticky",
        top: 0,
        bgcolor: "white",
        zIndex: 1000,
        padding: "16px 24px",
        borderBottom: 1,
        width: "100%",
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    },
    singleDropDown: {
        width: "100%"
    },
    saveModelButton: {
        width: "30%",
        textAlign: "right",
        display: 'flex',
        justifyContent: 'flex-end',
        marginRight: '15px'
    },
    numberInput: {
        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
            display: 'none',
        },
        '& input[type=number]': {
            MozAppearance: 'textfield',
        },
    },
    tableRowGraph: {
        justifyContent: 'center',
        textAlign: 'right'
    },
    tableSaveModel: {
        border: '1px solid #1b1b1b2b'
    },
    errorText: {
        color: "#FF4343",
        marginTop: "30px",
        fontSize: 14,
        display: "inline-block",
        padding: "12px 20px",
        backgroundColor: "#FFECEC",
        borderRadius: "4px",
        display: "flex",
        gap: "8px",
    },
    chipStyle: {
        marginLeft: 5,
        borderRadius: "4px",
        color: "#324054",
        backgroundColor: "#FFFFFF",
        border: "1px solid #868DAA",
        marginBottom: 5
    },
    renameColumnDiv: {
        height: '111px',
        overflowY: "auto",
        marginBottom: "20px"
    },
    valueText: {
        fontWeight: "bold",
        color: "#324054"
    },
    labelText: {
        fontSize: 14
    },
    saveColumnButton: {
        backgroundColor: "#005B96",
        color: "white",
        "&:hover": {
            backgroundColor: "#01446F",
        },
    },
    projectInitiationError: {
        marginLeft: "20px",
        fontSize: "12px"
    },
    stepCircle: {
        borderRadius: "50%",
        width: "50px",
        height: "50px",
        textAlign: "center",
        boxShadow: "0px 4px 8px #0000001F",
        cursor: "pointer",
    },
    stepNumber: {
        paddingTop: "12px",
        fontSize: "16px"
    },
    numericalColumnAddButton: {
        display: "flex",
        justifyContent: "flex-start",
        height: '100%'
    },
    dataTransformationContainer: {
        padding: "20px 0px 20px 20px",
        display: "flex"
    },
    uploadBtn: {
        backgroundColor: "#005B96",
        color: "#fff",
        '&.Mui-disabled': {
            backgroundColor: "#A9A9A9",
        },
    },
    customMappingChip: {
        display: "flex",
        gap: "5px",
        flexWrap: "wrap",
        margin: '0px'
    },
    customMappingTableCell: {
        textAlign: 'left',
        padding: '0px'
    },
    customMappingTextField: {
        height: 40,
        backgroundColor: 'white',
        width: 250,
        margin: '0px'
    },
    customMappingActionHeader: {
        width: '20%',
        textAlign: 'right'
    },
    downloadYamlBtn: {
        color: "#fff",
        backgroundColor: '#2A7BEC',
        color: "white",
        marginBottom: '20px',
        '&.Mui-disabled': {
            backgroundColor: "#A9A9A9",
        },
    },
    modelSavingContainer: {
        paddingLeft: "5%",
        paddingRight: "5%"
    },
    textCenterAlign: {
        alignItems: "center",
        fontSize: "14px"
    },
    customGridBackground: {
        paddingTop: 40,
        background: "linear-gradient(234.68deg, #F9F9F9 4.29%, #F2FAFF 125.55%)"
    },
    modelNameText: {
        color: "#324054",
        marginTop: "40px",
        fontWeight: 500,
        fontSize: 16,
    },
    tableRowBackground: {
        background: "linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9))"
    },
    responsiveTextField: {
        width: '90%',
        '@media (max-width:960px)': {
            width: '100%',
        },
    },
    loadingOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(128, 128, 128, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
    },
    sensorNamingPopup: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10000
    },
    popupContent: {
        backgroundColor: 'white',
        borderRadius: '8px',
        width: '560px',
        maxHeight: '80vh',
        overflowY: 'auto'
    },
    popupHeader: {
        fontSize: '18px',
        fontWeight: 600,
        color: '#324054',
        padding: '16px 32px',
        boxShadow: "0px 4px 40px 0px #00000014"
    },
    sensorLabel: {
        backgroundColor: '#32405414',
        color: '#005B96',
        width: "160px",
        height: '40px',
        borderRadius: '6px',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14px',
        fontWeight: 500,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineHeight: '40px',
        textAlign: 'center',
        padding: '0px 20px'
    },
    popupFooter: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '24px',
        gap: '12px',
        padding: '0px 24px'
    },
}));
exports.default = useAutomlStyles;
//# sourceMappingURL=style.js.map